module.exports = __webpack_public_path__ + "assets/0d0e8945a4fefd64544b4d0d9a23eb7f.jpg";